// extracted by mini-css-extract-plugin
export default {"jumbotron":"g_T","heroText":"g_V","heroDisclaimer":"g_W","heroButton":"g_X"};